import { useCallback } from "react";

import { SectionType } from "components/server-types";
import { ORDER_BY_TITLE } from "mds/hooks/use-ordered";
import { useAppSelector } from "store/index";
import { termSelectors } from "store/selectors";

export const useIsArchived = () => {
  const terms = useAppSelector(termSelectors.selectEntities);

  const isArchived = useCallback(
    (section: SectionType) => {
      const term = section.term_id ? terms[section.term_id] : undefined;
      return Boolean(section.archived_at || term?.archived_at);
    },
    [terms],
  );

  const isActive = useCallback((section: SectionType) => !isArchived(section), [isArchived]);

  const sortByActiveTitles = useCallback(
    (a: SectionType, b: SectionType) => {
      const aArchived = isArchived(a);
      const bArchived = isArchived(b);

      if (aArchived && !bArchived) return 1;
      if (!aArchived && bArchived) return -1;

      // eslint-disable-next-line babel/new-cap
      return ORDER_BY_TITLE(a, b);
    },
    [isArchived],
  );

  return { isArchived, isActive, sortByActiveTitles };
};
